import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { pipe } from 'fp-ts/function';
import { IconName } from '@optimus-web/icons';
import { Stack, StackItem, withBreakpointRange } from '@optimus-web/core';
import { DataTestId, SearchType } from '@mews-commander/enums';
import { ApplicationState, WithScope } from '@mews-commander/types';
import { WithBreakpointRange, isMobileOrTablet } from '@mews-commander/ui';
import { anonymizeUrl } from '@mews-commander/utils';
import { trackEvent } from '../../../middleware/createAnalyticsMiddleware';
import { navigateInBaseModal } from '../../app/actions/common';
import { NavbarSearchElement } from '../components/style';
import { getSearchTypes, getPlaceholder } from '../selectors';
import { NavbarIconButton } from '../../../components';
import Search from './SearchField';

const APP_NAVBAR_SEARCH_EVENT_CATEGORY = 'AppNavbarSearch';

interface Props extends WithScope, WithBreakpointRange {
    newEntity?: boolean;
    onHideClick?: () => void;
}

const NavbarSearch = ({ breakpointRange, onHideClick, ...other }: Props) => (
    <NavbarSearchElement breakpointRange={breakpointRange}>
        <Stack spacing="100">
            {isMobileOrTablet(breakpointRange) ? (
                <NavbarIconButton icon={IconName.ArrowLeft} onClick={onHideClick} />
            ) : null}
            <StackItem grow>
                {/* @ts-expect-error $TSFixMeError: No overload matches this call. */}
                <Search
                    {...other}
                    size="medium"
                    loaderVariant="inverse"
                    variant="contrast"
                    data-test-id={DataTestId.NavbarSearch}
                    inline
                    showSectionTitles
                    preserveSearchTermOnSelect
                />
            </StackItem>
        </Stack>
    </NavbarSearchElement>
);

NavbarSearch.defaultProps = {
    newEntity: true,
};

export default pipe(
    NavbarSearch,
    withBreakpointRange,
    connect(
        createStructuredSelector<ApplicationState, { searchTypes: SearchType[]; placeholder: string }>({
            searchTypes: getSearchTypes,
            placeholder: getPlaceholder,
        }),
        (dispatch) => ({
            onResultClick: ({ url, searchType }: $TSFixMe) => {
                dispatch(
                    trackEvent({
                        eventCategory: APP_NAVBAR_SEARCH_EVENT_CATEGORY,
                        eventAction: searchType,
                        eventLabel: anonymizeUrl(url),
                    })
                );
                // @ts-expect-error $TSFixMeError: Argument of type 'ThunkAction<Action<any>, void, ApplicationState>' is not assignable to parameter of type 'Action<any>'...
                dispatch(navigateInBaseModal(url));
            },
        })
    )
);
